export interface DeviceBehfa_Interface {
  id:number,
  id_temp:number,
  id_main:number,
  group_id:number,
  groupTitle:String,

  count:number,
  needCalibration:boolean,
  description:String,
  manufacturer:String,
  model:String,
  codeBEHFA:String,
  serial:string,
  countery:string,
  SellerContractor:number,
  seller:number,
  price:number,
  priceVahed:number,
  dateBuy:string,
  dateRun:string,
  fixer:string,
  type:string,

  scopework:string,
  acceptanceCriteria:string,
  initialStatus:boolean,
  calibrationPeriod:number,
  warningTime:number,

  technicalSpecifications:string,
  technicalDsc:string,
  environmentalConditions:string,
  jobAlerts:string,
  conditionKeep:string,
  conditionTransport:string,

  certificateNo:String,
  calibratingCompany:string,
  calibratingCustomer:string,
  calibratingName:string,
  calibratingNameType:string,
  uncertainty:string,

  calDueType:number,
  calDueMiladi:string,
  calDueShamsi:string,

  calDATEType:number,
  calDATEMiladi:string,
  calDATEShamsi:string,

  calibratingprice:number,
  calibratingpriceVahed:number,

  customerName:String,
  code:String,
  status:number,
  alarm:number,
  persianDate:String,
  uploadDate:String,
  downloadDate:String,
  downloadType:String,
  username:string,
  confirmer:string,
  confirmerDate:string,
  dsc:string,

  selected:boolean,
  del:boolean,
  cabinet_id: number,
  category_id: number,

  deviceBehfa_Schedule:Array<string>,
  performance:number,
}

export function Empty_DeviceBehfa_Interface():DeviceBehfa_Interface{
  return{
    id:0,
    id_temp:0,
    id_main:0,
    group_id:0,
    count:0,
    groupTitle:'',

    needCalibration:false,
    description:'',
    manufacturer:'',
    model:'',
    codeBEHFA:'',
    serial:'',
    countery:'',
    seller:0,
    SellerContractor:0,
    price:0,
    priceVahed:0,
    dateBuy:'',
    dateRun:'',
    fixer:'-1',

    scopework:'',
    acceptanceCriteria:'',
    initialStatus:false,
    calibrationPeriod:0,
    warningTime:0,

    technicalSpecifications:'',
    technicalDsc:'',
    environmentalConditions:'',
    jobAlerts:'',
    conditionKeep:'',
    conditionTransport:'',
    type:'',

    certificateNo:'',
    calibratingCompany:'',
    calibratingCustomer:'',
    calibratingName:'',
    calibratingNameType:'',
    uncertainty:'',

    calDueType:0,
    calDueMiladi:'',
    calDueShamsi:'',

    calDATEType:0,
    calDATEMiladi:'',
    calDATEShamsi:'',

    calibratingprice:0,
    calibratingpriceVahed:0,

    customerName:'',
    code:'',
    status:0,
    alarm:0,
    persianDate:'',
    uploadDate:'',
    downloadDate:'',
    downloadType:'',
    username:'',
    confirmer:'',
    confirmerDate:'',
    dsc:'',

    selected:false,
    del: false,

    cabinet_id: 0,
    category_id: 0,
    deviceBehfa_Schedule:[],
    performance:0
  }
}
